import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../images/site_logo/site_logo_1.svg";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <header className={`site_header  ${isSticky ? "sticky" : ""}`}>
      <div className="nav_wrapper">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-2 col-5 d-flex align-items-center">
              <div className="site_logo">
                <NavLink className="site_link" to="/" onClick={ClickHandler}>
                  <img loading="lazy" src={Logo} alt="TopCoin Uk" />
                </NavLink>
              </div>
            </div>
            <div className="col-lg-9 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className={`main_menu_inner collapse navbar-collapse justify-content-center ${
                    mobailActive ? "show" : ""
                  }`}
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list text-uppercase main-menu">
                    <li>
                      <NavLink
                        to="/"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span className="nav_link_label" data-text="Home">
                          Home
                        </span>
                      </NavLink>
                    </li>
                      <li>
                      <NavLink
                        to="/about"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span className="nav_link_label" data-text="About">
                          About
                        </span>
                      </NavLink>
                    </li>
                     <li>
                      <NavLink
                        to="/blockchain"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="nav-link scrollspy_btn"
                      >
                        <span className="nav_link_label" data-text="Blockchain">
                          Blockchain
                        </span>
                      </NavLink>
                    </li>
                     
                  

                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/wallets"
                      >
                        <span
                          className="nav_link_label"
                          data-text="How TCUK Wallets Values Calculated"
                        >
                          How TCUK Wallets Values Calculated
                        </span>
                      </NavLink>
                    </li>
                       <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/tuck-units"
                      >
                        <span
                          className="nav_link_label"
                          data-text="TCUK Wallets & Values"
                        >
                         TCUK Wallets & Values
                        </span>
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/faq"
                      >
                        <span className="nav_link_label" data-text="Faq">
                          Faq
                        </span>
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/contact"
                      >
                        <span className="nav_link_label" data-text="Contact">
                          Contact
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                  <MobileMenu />
                </div>
              </nav>
            </div>
            <div className="col-lg-1 col-5">
              <ul className="btns_group unordered_list p-0 justify-content-end">
                <li className="d-lg-none">
                  <button
                    className="mobile_menu_btn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_menu_dropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMobailState(!mobailActive)}
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li>
                  <NavLink
                    onClick={ClickHandler}
                    className="ico_btn_outline"
                    to="/sign_in"
                  >
                    {/* <span className="btn_icon">
                                            <i className="fa-solid fa-user"></i>
                                        </span> */}
                    <span className="btn_label">Login</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
